export default __webpack_public_path__ + "static/organizations-1-77a5e25e71a6789108ca24715c15998c.jpg";